import "./patientMeasurement.scss";
import "../../steps/forms.scss";
import FormTitle from "../../components/formTitle/FormTitle";
import MuiRadio from "../../components/radio/MuiRadio";
import RangeSlider from "../../components/range/RangeSlider";
import InputTextField from "../../components/textField/InputTextField";
import SocketMaterial from "../../components/socketMaterial/SocketMaterial";
import OrderFormStep from "../../common/OrderFormStep";
import FieldState from "../../common/FieldState";
import Config from "../../common/Config";
import axios from "axios";
import Button from "../../components/button/Button";
import SecondaryButton from "../../components/button/SecondaryButton";
import { Form } from "react-bootstrap";
import tfDefinitive from "../../images/tfDefinitive.png";
import { CreateNotification } from "../../components/notification/Notification";
import SaveAsDraft from "../../components/modal/SaveAsDraft";
import ClearOrder from "../../components/modal/ClearOrder";
import MuiCheckbox from "../../components/checkbox/MuiCheckbox";

import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

class TFDefinitiveMeasurement extends OrderFormStep {
  constructor(props) {
    super(props);

    this.fromCarbonCastId = 110;
    this.fromCADFileId = 111;
    this.fromCastId = 98;
    this.fromScanId = 100;

    this.uomMetric = 67;
    this.uomImperial = 68;

    this.conversionFactor = 2.54;
    this.maxCMProstheticHeightAdjustment = 12;
    this.maxInchProstheticHeightAdjustment = 5;

    this.shortenId = 29;
    this.extendId = 30;

    this.additionalWindowId = 160;

    this.nextCartQueueIndex=0;
    this.displayedCartIndex=0;

    this.customerSuppliedFabricId = 22;
    this.customerSuppliedLockId = 43;
    this.customerSuppliedPlateId = 50;
    this.customerSuppliedValveId = 58;

    this.installAndShapeTTFoamCoverId = 157;
    this.polypropyleneCopolymerId = 109;

    this.state = {
      modifications: [],
      estimatedShipDate: null,
      socketOptions: [],
      socketMaterials: [],
      insertMaterials: [],
      locks: [],
      valves: [],
      mountingPlates: [],
      prostheticHeightUOMs: [],
      prostheticHeights: [],
      revoFitOptions: [],
      UOMs: [],
      isSubmit: false,
      selectedValue: 0,
      socketFinishes: [],
      cartRequestIndex: 0,
      patientId: null,
      formState: {
        // shapeCreation: new FieldState(true),
        socketFinish: new FieldState(true),
        cadFile: new FieldState(false),
        cadFileName: new FieldState(false),
        castShippedSeparately: new FieldState(false),
        scanFileName: new FieldState(false),
        // socketStyle: new FieldState(true),
        // trimline: new FieldState(true),
        modification: new FieldState(true),
        modificationPercentage: new FieldState(false, 0),
        socketOption: new FieldState(false, {}),
        socketMaterial: new FieldState(true),
        insertMaterial: new FieldState(false, {}),
        lock: new FieldState(true),
        valve: new FieldState(true),
        mountingPlate: new FieldState(true),
        customerSuppliedPlate: new FieldState(false),
        customerSuppliedLock: new FieldState(false),
        customerSuppliedValve: new FieldState(false),
        customerSuppliedFabric: new FieldState(false),
        prostheticHeightUOM: new FieldState(false, this.uomImperial),
        prostheticHeight: new FieldState(true),
        amount: new FieldState(false, 0),
        revoFitEnabled: new FieldState(false, false),
        revoFit: new FieldState(false, {}),
        additionalRevoFitWindows: new FieldState(false, 0),
        UOM: new FieldState(false),
        ITToFloor: new FieldState(false),
        ThighToFloor: new FieldState(false),
        KCToFloor: new FieldState(false),
        CalfToFloor: new FieldState(false),
        ThighCirc: new FieldState(false),
        KCCirc: new FieldState(false),
        CalfCirc: new FieldState(false),
        AnkleCirc: new FieldState(false),
        itemsSentIn: new FieldState(true),
        notes: new FieldState(false),
      },
    };

    this.onFileChange = this.onFileChange.bind(this);
    this.onCheckChange = this.onCheckChange.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.getNextCartQueueIndex = this.getNextCartQueueIndex.bind(this);
    this.shouldDisplayCart = this.shouldDisplayCart.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.addFile = this.addFile.bind(this);
  }

  getNextCartQueueIndex() {
    return this.nextCartQueueIndex++;
  }

  shouldDisplayCart(index) {
    if(index >= this.displayedCartIndex) {
      this.displayedCartIndex = index;
      return true;
    }

    return false;
  }

  loadCart() {    
    this.updateSocketRequired();

    let cart = [];

    let addToCart = (options, selectedId, sourceId) => {
      let item = options.filter(x => x.id===selectedId)[0];
      let windowQuantity = this.state.formState.additionalRevoFitWindows.value;
      if(item && item.partNumbers && item.partNumbers.length > 0) {
        item.partNumbers.forEach(part => {
          cart.push({
            name: item.displayName,
            partNumber: part,
            quantity: (selectedId === this.additionalWindowId) ? windowQuantity : 1,
            price: -1,
            sourceId: sourceId
          });
        });
      } else {
        cart.push({
            name: null,
            partNumber: null,
            quantity: 0,
            price: 0,
            sourceId: sourceId
          });
      }
    }

    
    addToCart(this.state.socketMaterials, this.state.formState.socketMaterial.value, "socketMaterial");
    addToCart(this.state.locks, this.state.formState.lock.value, "lock");
    addToCart(this.state.valves, this.state.formState.valve.value, "valve");
    addToCart(this.state.mountingPlates, this.state.formState.mountingPlate.value, "mountingPlate");
    addToCart(this.state.socketFinishes, this.state.formState.socketFinish.value, "socketFinish");

    for (let i = 0; i < this.state.insertMaterials.length; i++) {
      let fieldOptionId = this.state.insertMaterials[i].id;

      if(this.state.formState.insertMaterial.value[fieldOptionId]) {
        addToCart(this.state.insertMaterials, fieldOptionId, "" + fieldOptionId);
      } else {
        addToCart(this.state.insertMaterials, null, "" + fieldOptionId);
      }
    }

     for (let i = 0; i < this.state.socketOptions.length; i++) {
      let fieldOptionId = this.state.socketOptions[i].id;

      if(this.state.formState.socketOption.value[fieldOptionId]) {
        addToCart(this.state.socketOptions, fieldOptionId, "" + fieldOptionId);
      } else {
        addToCart(this.state.socketOptions, null, "" + fieldOptionId);
      }
    }

    for (let i = 0; i < this.state.revoFitOptions.length; i++) {
      let fieldOptionId = this.state.revoFitOptions[i].id;

      if(this.state.formState.revoFit.value[fieldOptionId]) {
        addToCart(this.state.revoFitOptions, fieldOptionId, "" + fieldOptionId);
        } {
        addToCart(this.state.revoFitOptions, null, "" + fieldOptionId);
      }
    }
    
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };
    config.params = {
      cart: cart.map(x => x.partNumber)
    }

    const index = this.getNextCartQueueIndex();
    
    return this.loadShipDate()
      .then(r1 => {
        return axios.get(
          Config.baseApiUrl + "price/" + this.props.formTypeId,
          config
        ).then(response => {
          let data = response.data
  
          cart = cart.map(c => {
            return {
              key: c.partNumber,
              name: c.name,
              partNumber: c.partNumber,
              quantity: c.quantity,
              price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
              sourceId: c.sourceId
            }
          })

          cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
            return {
              key: d.partNumber,
              name: d.name,
              partNumber: d.partNumber,
              quantity: d.quantity,
              price: d.price,
              sourceId: d.sourceId
            }
          }));
          
          if(this.shouldDisplayCart(index)) {
            this.props.setTempCart(cart);
          }
        }).catch(error =>{
          console.log(error)
        })
      });
  }

  handleAmountUnit = (e) => {
    this.setState({ unit: e.target.value });
    this.props.setActiveInnerStep(7);
  };

  handleAmountChange(e, value) {
    let formState = this.state.formState;
    if (value == "UOM") {
      formState.amount.value = e;
    } else {
      formState.modificationPercentage.value = e;
    }
    this.setState({ formState: formState, hasDataChanged: true });
  }

  onFileChange(e) {
    const file = e.target.files[0];
    if (file === undefined) {
      return null;
    }
    if (file.size >= 8000000) {
      CreateNotification("File size must be less than 8 MB", "error");
      return null;
    }
    let formState = this.state.formState;
    const previouslyUploadedFileName = formState.cadFileName.value;
    formState.cadFileName.value = "";
    const newFileName = this.renameFile(file);
    if (newFileName !== null) {
      formState.cadFile.value = newFileName;
      formState.cadFile.isRequired = this.isFromCADFileSelected();
    } else {
      formState.cadFileName.value = previouslyUploadedFileName;
    }
    this.setState({ formState: formState, hasDataChanged: true });
  }

  renameFile(file) {
    const oldName = file?.name;
    if (oldName === undefined) {
      return null;
    }
    const oldFileType = oldName.split(".").slice(-1)[0];
    if (this.validFileTypes(oldFileType)) {
      const newName = Date.now() + "_" + this.state.patientId + "." + oldFileType;
      this.state.formState.cadFileName.value = newName;
      return new File([file], newName);
    } else {
      CreateNotification("File type must be .stl, .obj or .aop", "error");
      return null;
    }
  }

  validFileTypes(oldFileType) {
    return (oldFileType === 'stl' || oldFileType === 'obj' || oldFileType === 'aop')
  }

  isFromCADFileSelected() {
    return this.state.formState.socketMaterial.value === this.fromCADFileId;
  }

  onCheckChange(e) {
    let formState = this.state.formState;
    formState.castShippedSeparately.value = e.target.checked;
    this.setState({ formState: formState, hasDataChanged: true });

    this.loadCart();
  }

  componentDidMount() {
    this.loadData();
    this.loadMeasureData();
  }

  async loadShipDate() {
    try {
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
      };
      let estimatedShipDate = (
        await axios.get(
          Config.baseApiUrl + "shipDate/" + this.props.formTypeId,
          config
        )
      ).data;

      this.setState({
        estimatedShipDate: estimatedShipDate,
      });
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }

  async loadData() {
    try {
      this.setState({
        // shapeCreations: (
        //   await axios.get(
        //     Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
        //     {
        //       params: { fieldName: "shapeCreation" },
        //     }
        //   )
        // ).data,
        // socketStyles: (
        //   await axios.get(
        //     Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
        //     {
        //       params: { fieldName: "socketStyle" },
        //     }
        //   )
        // ).data,
        // trimlines: (
        //   await axios.get(
        //     Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
        //     {
        //       params: { fieldName: "trimline" },
        //     }
        //   )
        // ).data,

        modifications: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "modification" },
            }
          )
        ).data,

        insertMaterials: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "insertMaterial" },
            }
          )
        ).data,

        socketFinishes: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "socketFinish" } }
          )
        ).data,

        socketMaterials: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "socketMaterial" } }
          )
        ).data,

        socketOptions: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "socketOption" } }
          )
        ).data,

        locks: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "lock" },
            }
          )
        ).data,
        valves: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "valve" },
            }
          )
        ).data,
        mountingPlates: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "mountingPlate" },
            }
          )
        ).data,

        prostheticHeightUOMs: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "prostheticHeightUOM" } }
          )
        ).data,
        prostheticHeights: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "prostheticHeight" } }
          )
        ).data,
        revoFitOptions: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "revoFit" } }
          )
        ).data,
      });

      let formState = this.state.formState;

      let headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
      };
      let cadFileConfig = {
        headers: headers,
      };

      const cadFile = (
        await axios.get(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          cadFileConfig
        )
      ).data;
      formState.cadFileName.value = cadFile !== null ? cadFile.cadFileName : "";

      let patientInfo1Config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: ["patientInfo1UOM", "height", "weight"],
        },
      };

      if (this.props.uniqueId != null) {
        patientInfo1Config.headers.UniqueId = this.props.uniqueId;
      }

      let patientInfo1Data = (
        await axios.get(
          Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId,
          patientInfo1Config
        )
      ).data.patientId;

      this.setState({
        patientId: patientInfo1Data
      })

      this.loadShipDate();
      let config = {
        headers: headers,
        params: {
          fieldNames: [
            // "shapeCreation",
            "castShippedSeparately",
            // "socketStyle",
            // "trimline",
            "modification",
            "modificationPercentage",
            "modificationPly",
            "brim",
            "brimOther",
            "socketOption",
            "socketMaterial",
            "insertMaterial",
            "lock",
            "valve",
            "mountingPlate",
            "customerSuppliedPlate",
            "customerSuppliedLock",
            "customerSuppliedValve",
            "customerSuppliedFabric",
            "prostheticHeightUOM",
            "prostheticHeight",
            "shorten",
            "extend",
            "revoFitEnabled",
            "revoFit",
            "additionalRevoFitWindows",
            "itemsSentIn",
            "notes",
            "socketFinish",
          ],
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        config
      );
      
      // formState.shapeCreation.value = data.find(
      //   (fi) => fi.fieldName === "shapeCreation"
      // ).fieldOptionId;
      formState.castShippedSeparately.value = data.find(
        (fi) => fi.fieldName === "castShippedSeparately"
      ).booleanData;
      // formState.scanFileName.value = data.find(
      //   (fi) => fi.fieldName === "scanFileName"
      // ).stringData;

      // formState.trimline.value = data.find(
      //   (fi) => fi.fieldName === "trimline"
      // ).fieldOptionId;

      // formState.socketStyle.value = data.find(
      //   (fi) => fi.fieldName === "socketStyle"
      // ).fieldOptionId;

      // formState.modification.value = data.find(
      //   (fi) => fi.fieldName === "modification"
      // ).fieldOptionId;


      formState.socketMaterial.value = data.find(
        (fi) => fi.fieldName === "socketMaterial"
      ).fieldOptionId;

      formState.socketFinish.value = data.find(
        (fi) => fi.fieldName === "socketFinish"
      ).fieldOptionId;

      formState.lock.value = data.find(
        (fi) => fi.fieldName === "lock"
      ).fieldOptionId;

      formState.valve.value = data.find(
        (fi) => fi.fieldName === "valve"
      ).fieldOptionId;

      formState.mountingPlate.value = data.find(
        (fi) => fi.fieldName === "mountingPlate"
      ).fieldOptionId;

      formState.customerSuppliedPlate.value = data.find(
        (fi) => fi.fieldName === "customerSuppliedPlate"
      ).stringData;

      formState.customerSuppliedLock.value = data.find(
        (fi) => fi.fieldName === "customerSuppliedLock"
      ).stringData;

      formState.customerSuppliedValve.value = data.find(
        (fi) => fi.fieldName === "customerSuppliedValve"
      ).stringData;

      formState.customerSuppliedFabric.value = data.find(
        (fi) => fi.fieldName === "customerSuppliedFabric"
      ).stringData;

      formState.itemsSentIn.value = data.find(
        (fi) => fi.fieldName === "itemsSentIn"
      ).stringData;
      formState.notes.value = data.find(
        (fi) => fi.fieldName === "notes"
      ).stringData;

      formState.prostheticHeightUOM.value =
        data.find((fi) => fi.fieldName === "prostheticHeightUOM")
          .fieldOptionId ?? this.uomImperial;

      formState.prostheticHeight.value = data.find(
        (fi) => fi.fieldName === "prostheticHeight"
      ).fieldOptionId;

      for (let i = 0; i < this.state.insertMaterials.length; i++) {
        let fieldOptionId = this.state.insertMaterials[i].id;
        let fieldInput = data.find(
          (fi) =>
            fi.fieldName === "insertMaterial" &&
            fi.fieldOptionId === fieldOptionId
        );

        if (fieldInput !== undefined) {
          formState.insertMaterial.value[fieldOptionId] =
            fieldInput.booleanData;
        } else {
          formState.insertMaterial.value[fieldOptionId] = false;
        }
      }

      for (let i = 0; i < this.state.socketOptions.length; i++) {
        let fieldOptionId = this.state.socketOptions[i].id;
        let fieldInput = data.find(
          (fi) =>
            fi.fieldName === "socketOption" &&
            fi.fieldOptionId === fieldOptionId
        );

        if (fieldInput !== undefined) {
          formState.socketOption.value[fieldOptionId] =
            fieldInput.booleanData;
        } else {
          formState.socketOption.value[fieldOptionId] = false;
        }
      }

      if (this.state.formState.prostheticHeight.value === this.shortenId) {
        formState.amount.value = data.find(
          (fi) => fi.fieldName === "shorten"
        ).numericData;
        
      } else if (formState.prostheticHeight.value === this.extendId) {
        formState.amount.value = data.find(
          (fi) => fi.fieldName === "extend"
        ).numericData;
      }

      formState.modification.value = data.find(
        (fi) => fi.fieldName === "modification"
      ).fieldOptionId;
      
      if (this.state.formState.modification.value === 152) {
        formState.modificationPercentage.value = data.find(
          (fi) => fi.fieldName === "modificationPercentage"
        ).numericData;
      } else if (this.isPlySelected()) {
        formState.modificationPercentage.value = data.find(
          (fi) => fi.fieldName === "modificationPly"
        ).numericData;
      }

      for (let i = 0; i < this.state.revoFitOptions.length; i++) {
        let fieldOptionId = this.state.revoFitOptions[i].id;
        let fieldInput = data.find(
          (fi) =>
            fi.fieldName === "revoFit" && fi.fieldOptionId === fieldOptionId
        );

        if (fieldInput !== undefined) {
          formState.revoFit.value[fieldOptionId] = fieldInput.booleanData;
        } else {
          formState.revoFit.value[fieldOptionId] = false;
        }
      }

      formState.revoFitEnabled.value =
        data.find((fi) => fi.fieldName === "revoFitEnabled").booleanData ??
        false;

      if (this.isAdditionalWindowSelected()) {
        formState.additionalRevoFitWindows.value = data.find(
          (fi) => fi.fieldName === "additionalRevoFitWindows"
        ).numericData;
      }

      formState.cadFileName.isRequired = this.isFromCADFileSelected();
      // formState.scanFileName.isRequired = this.isFromScanSelected();
      
      this.setState({ formState: formState });

      this.loadCart();
      this.getFormSteps();
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }

    this.setState({ isLoaded: true });
  }

  getFieldInputPromise() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let fieldInputData = [];

    fieldInputData.push({
      fieldName: "castShippedSeparately",
      booleanData: this.state.formState.castShippedSeparately.value,
    });

    fieldInputData.push({
      fieldName: "socketFinish",
      fieldOptionId: this.state.formState.socketFinish.value,
    });

    fieldInputData.push({
      fieldName: "socketMaterial",
      fieldOptionId: this.state.formState.socketMaterial.value,
    });

    fieldInputData.push({
      fieldName: "lock",
      fieldOptionId: this.state.formState.lock.value,
    });

    fieldInputData.push({
      fieldName: "valve",
      fieldOptionId: this.state.formState.valve.value,
    });

    fieldInputData.push({
      fieldName: "mountingPlate",
      fieldOptionId: this.state.formState.mountingPlate.value,
    });


    fieldInputData.push({
      fieldName: "prostheticHeight",
      fieldOptionId: this.state.formState.prostheticHeight.value,
    });

    fieldInputData.push({
      fieldName: "prostheticHeightUOM",
      fieldOptionId:
        this.isShortenSelected() || this.isExtendSelected()
          ? this.state.formState.prostheticHeightUOM.value
          : null,
    });

    fieldInputData.push({
      fieldName: "itemsSentIn",
      stringData: this.state.formState.itemsSentIn.value,
    });

    fieldInputData.push({
      fieldName: "notes",
      stringData: this.state.formState.notes.value,
    });

    fieldInputData.push({
      fieldName: "shorten",
      numericData: this.isShortenSelected()
        ? this.state.formState.amount.value
        : null,
    });

    fieldInputData.push({
      fieldName: "extend",
      numericData: this.isExtendSelected()
        ? this.state.formState.amount.value
        : null,
    });

    for (let i = 0; i < this.state.insertMaterials.length; i++) {
      let fieldOptionId = this.state.insertMaterials[i].id;

      fieldInputData.push({
        fieldName: "insertMaterial",
        fieldOptionId: fieldOptionId,
        booleanData: this.state.formState.insertMaterial.value[fieldOptionId] ?? false,
        dataIndex: i,
      });
    }

    for (let i = 0; i < this.state.socketOptions.length; i++) {
      let fieldOptionId = this.state.socketOptions[i].id;

      fieldInputData.push({
        fieldName: "socketOption",
        fieldOptionId: fieldOptionId,
        booleanData: this.state.formState.socketOption.value[fieldOptionId] ?? false,
        dataIndex: i,
      });
    }

    for (let i = 0; i < this.state.revoFitOptions.length; i++) {
      let fieldOptionId = this.state.revoFitOptions[i].id;

      let booleanData =
        this.state.formState.revoFitEnabled.value &&
        this.state.formState.revoFit.value[fieldOptionId];

      fieldInputData.push({
        fieldName: "revoFit",
        fieldOptionId: fieldOptionId,
        booleanData: booleanData,
        dataIndex: i,
      });
    }

    fieldInputData.push({
      fieldName: "revoFitEnabled",
      booleanData: this.state.formState.revoFitEnabled.value,
    });

    fieldInputData.push({
      fieldName: "additionalRevoFitWindows",
      numericData: this.isAdditionalWindowSelected()
        ? this.state.formState.additionalRevoFitWindows.value
        : null,
    });

    fieldInputData.push({
      fieldName: "modification",
      fieldOptionId: this.state.formState.modification.value,
    });

    fieldInputData.push({
      fieldName: "modificationPercentage",
      numericData:
        this.state.formState.modification.value === 152
          ? this.state.formState.modificationPercentage.value
          : null,
    });

    fieldInputData.push({
      fieldName: "modificationPly",
      numericData: this.isPlySelected()
        ? this.state.formState.modificationPercentage.value
        : null,
    });
    fieldInputData.push({
      fieldName: "customerSuppliedPlate",
      stringData:  this.state.formState.mountingPlate.value === this.customerSuppliedPlateId 
      ? this.state.formState.customerSuppliedPlate.value 
      : null,
    });

    fieldInputData.push({
      fieldName: "customerSuppliedLock",
      stringData: this.state.formState.lock.value === this.customerSuppliedLockId
      ? this.state.formState.customerSuppliedLock.value 
      : null,
    });

    fieldInputData.push({
      fieldName: "customerSuppliedValve",
      stringData: this.state.formState.valve.value === this.customerSuppliedValveId 
      ? this.state.formState.customerSuppliedValve.value 
      : null,
    });

    fieldInputData.push({
      fieldName: "customerSuppliedFabric",
      stringData: this.state.formState.socketFinish.value === this.customerSuppliedFabricId 
      ? this.state.formState.customerSuppliedFabric.value 
      : null,
    });

    return axios.post(
      Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
      fieldInputData,
      config
    )
  }

  getAmountText(section) {
    let amountText;
    let amount;

    if (section == "UOM") {
      if (this.isCMSelected()) {
        return " cm";
      } else {
        return " in";
      }
    }
    else {
      amount = this.state.formState.modificationPercentage.value;
      if (this.isPercentageSelected()) {
        amountText = "%";
      } else {
        amountText = " Ply";
      }

      if (amount >= 0) {
        amountText += " Increase";
      } else {
        amountText += " Reduction";
      }
    }
    return amountText;
  }

  isPercentageSelected() {
    return this.state.formState.modification.value === 152;
  }

  isPlySelected() {
    return this.state.formState.modification.value === 153;
  }

  saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let promises = [];

    const fields = [
      "UOM",
      "ITToFloor",
      "ThighToFloor",
      "KCToFloor",
      "CalfToFloor",
      "ThighCirc",
      "KCCirc",
      "CalfCirc",
      "AnkleCirc",
    ];

    if (this.state.formState.cadFile.value !== "" && this.isFromCADFileSelected()) {
      const formData = new FormData();

      formData.append(
        "cadFile",
        this.state.formState.cadFile.value,
        this.state.formState.cadFile.value.name
      );

      promises.push(
        axios.post(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          formData,
          config
        )
      );
    }

    if (this.state.formState.cadFileName.value != "" && !this.isFromCADFileSelected())
    {
      const formData = new FormData();

      formData.append(
        "cadFile",
        null,
      );

      promises.push(
        axios.put(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          formData,
          config
        )
      );
    }

    if (!this.state.formState.socketOption.value[157]) {
      for (let i = 0; i < fields.length; i++) {
        this.state.formState[fields[i]].isRequired = false;
      }
    } else {
      for (let i = 0; i < fields.length; i++) {
        this.state.formState[fields[i]].isRequired = true;
      }
    }

    if (this.validateData().isValid) {
      if (this.state.formState.socketOption.value[157]) {
        promises.push(this.saveMeasureData());
      }
      promises.push(this.getFieldInputPromise());
      axios
        .all(promises)
        .then(
          axios.spread((res, res2) => {
            if (res2) {
              if (
                (res.status === 200 || res.status === 204) &&
                (res2.status === 200 || res2.status === 204)
              ) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
              }
            } else {
              if (res.status === 200 || res.status === 204) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
              }
            }
          })
        )
        .catch((error) => {
          console.log(error);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");
      this.setState({ isLoading: false });
    }
  }

  async loadMeasureData() {
    try {
      this.setState({
        UOMs: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "UOM" } }
          )
        ).data,
      });

      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
        },
        params: {
          fieldNames: [
            "UOM",
            "ITToFloor",
            "ThighToFloor",
            "KCToFloor",
            "CalfToFloor",
            "ThighCirc",
            "KCCirc",
            "CalfCirc",
            "AnkleCirc",
          ],
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        config
      );
      let formState = this.state.formState;
      formState.UOM.value = data.find(
        (fi) => fi.fieldName === "UOM"
      ).fieldOptionId;
      formState.ITToFloor.value =
        data.find((fi) => fi.fieldName === "ITToFloor").numericData ?? "";
      formState.ThighToFloor.value =
        data.find((fi) => fi.fieldName === "ThighToFloor").numericData ?? "";
      formState.KCToFloor.value =
        data.find((fi) => fi.fieldName === "KCToFloor").numericData ?? "";
      formState.CalfToFloor.value =
        data.find((fi) => fi.fieldName === "CalfToFloor").numericData ?? "";
      formState.ThighCirc.value =
        data.find((fi) => fi.fieldName === "ThighCirc").numericData ?? "";
      formState.KCCirc.value =
        data.find((fi) => fi.fieldName === "KCCirc").numericData ?? "";
      formState.CalfCirc.value =
        data.find((fi) => fi.fieldName === "CalfCirc").numericData ?? "";
      formState.AnkleCirc.value =
        data.find((fi) => fi.fieldName === "AnkleCirc").numericData ?? "";

      this.setState({ formState: formState });
    } catch (error) {
      // this.props.handleError(new LoadFailureResult());
    }

    // this.setState({ isLoaded: true });
  }

  saveMeasureData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let data = [];

    data.push({
      fieldName: "UOM",
      fieldOptionId: this.state.formState.UOM.value,
    });

    data.push({
      fieldName: "ITToFloor",
      numericData: this.state.formState.ITToFloor.value,
    });

    data.push({
      fieldName: "ThighToFloor",
      numericData: this.state.formState.ThighToFloor.value,
    });

    data.push({
      fieldName: "KCToFloor",
      numericData: this.state.formState.KCToFloor.value,
    });

    data.push({
      fieldName: "CalfToFloor",
      numericData: this.state.formState.CalfToFloor.value,
    });

    data.push({
      fieldName: "ThighCirc",
      numericData: this.state.formState.ThighCirc.value,
    });

    data.push({
      fieldName: "KCCirc",
      numericData: this.state.formState.KCCirc.value,
    });

    data.push({
      fieldName: "CalfCirc",
      numericData: this.state.formState.CalfCirc.value,
    });

    data.push({
      fieldName: "AnkleCirc",
      numericData: this.state.formState.AnkleCirc.value,
    });

    return axios.post(
      Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
      data,
      config
    );
  }

  handleSliderChange(newValue) {
    this.props.setActiveInnerStep(8);
  }

  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  convertToISOString(dateString) {
    const dateParts = dateString.split("-");
    const convertedDate = new Date(
      dateParts[0],
      dateParts[1] - 1,
      dateParts[2]
    );

    return convertedDate;
  }
  formatDateToString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  removeFile() {
    this.state.formState.cadFile.isRequired = false;
    this.state.formState.cadFileName.isRequired = false;
    this.setState({ formState: this.state.formState, hasDataChanged: true });
  }

  addFile() {
    if (this.state.formState.cadFileName.value !== "") {
      this.state.formState.cadFileName.isRequired = false;
    } else {
      this.state.formState.cadFileName.isRequired = true;
    }
    this.setState({ formState: this.state.formState, hasDataChanged: true });
  }

  getFormSteps() {
    let itemsToHide = []
    if (!this.state.formState.socketOption.value[this.installAndShapeTTFoamCoverId]) {
      itemsToHide.push(2);
    }
    if (this.state.formState.socketMaterial.value === this.polypropyleneCopolymerId) {
      itemsToHide.push(5);
      itemsToHide.push(12);
    }
    this.props.getFormSteps(itemsToHide);
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    return (
      <div className="tfMeasuremnet">
        <div className="checkFormWrapper">
          <FormTitle
            title="Product Information"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>
            <div className="socketOption">
              <div className="fieldBorder">
              <MuiCheckbox
                checkboxes={this.state.socketOptions}
                boxLabel="Socket Option"
                onChange={(e, id) => {
                  if (id === this.exoskeletalLaminationId && this.state.formState.socketMaterial.value === this.polypropyleneCopolymerSelectedId) {
                    let formState = this.state.formState;
                    formState.socketMaterial.value = null;
                  }
                  this.onCheckboxChange(e, id, "socketOption");
                  this.props.setActiveInnerStep(1);
                  this.getFormSteps()
                }}
                defaultValue={this.state.formState.socketOption.value}
                error={this.handleError("socketOption") && this.state.isSubmit}
                required={this.state.formState["socketOption"].isRequired}
              />
              <div>
                {(this.state.formState.socketOption.value[157]) && (
                  <div className="tfDefinitive">
                    <div className="colorRadio"></div>
                    <div className="unitWrapper">
                      <MuiRadio
                        options={this.state.UOMs}
                        defaultValue={this.state.formState.UOM.value}
                        label="Unit of Measurement"
                        required={true}
                        onChange={(e) => {
                          this.props.setActiveInnerStep(2);
                          this.onRadioChange(e, "UOM");
                        }}
                      />
                      <div className="measureImg">
                        <img
                          src={tfDefinitive}
                          alt="measure"
                          width="297"
                          height="315px"
                        />

                        <div className="inputs">
                          <div className="floor">
                            <InputTextField
                              placeholder=""
                              type="text"
                              value={this.state.formState.ITToFloor.value}
                              error={
                                this.handleError("ITToFloor") &&
                                this.state.isSubmit
                              }
                              onChange={(e) => {
                                this.onInputChange(e, "ITToFloor");
                              }}
                            />
                          </div>

                          <div className="calf">
                            <InputTextField
                              placeholder=""
                              type="text"
                              value={this.state.formState.ThighToFloor.value}
                              error={
                                this.handleError("ThighToFloor") &&
                                this.state.isSubmit
                              }
                              onChange={(e) => {
                                this.onInputChange(e, "ThighToFloor");
                              }}
                            />
                          </div>

                          <div className="largestCalf">
                            <InputTextField
                              placeholder=""
                              type="text"
                              value={this.state.formState.KCToFloor.value}
                              error={
                                this.handleError("KCToFloor") &&
                                this.state.isSubmit
                              }
                              onChange={(e) => {
                                this.onInputChange(e, "KCToFloor");
                              }}
                            />
                          </div>

                          <div className="largestAnkle">
                            <InputTextField
                              placeholder=""
                              type="text"
                              value={this.state.formState.CalfToFloor.value}
                              error={
                                this.handleError("CalfToFloor") &&
                                this.state.isSubmit
                              }
                              onChange={(e) => {
                                this.onInputChange(e, "CalfToFloor");
                              }}
                            />
                          </div>

                          <div className="tightFloor">
                            <InputTextField
                              placeholder=""
                              type="text"
                              value={this.state.formState.ThighCirc.value}
                              error={
                                this.handleError("ThighCirc") &&
                                this.state.isSubmit
                              }
                              onChange={(e) => {
                                this.onInputChange(e, "ThighCirc");
                              }}
                            />
                          </div>

                          <div className="kcFloor">
                            <InputTextField
                              placeholder=""
                              type="text"
                              value={this.state.formState.KCCirc.value}
                              error={
                                this.handleError("KCCirc") &&
                                this.state.isSubmit
                              }
                              onChange={(e) => {
                                this.onInputChange(e, "KCCirc");
                              }}
                            />
                          </div>

                          <div className="kc">
                            <InputTextField
                              placeholder=""
                              type="text"
                              value={this.state.formState.CalfCirc.value}
                              error={
                                this.handleError("CalfCirc") &&
                                this.state.isSubmit
                              }
                              onChange={(e) => {
                                this.onInputChange(e, "CalfCirc");
                              }}
                            />
                          </div>

                          <div className="midThigh">
                            <InputTextField
                              placeholder=""
                              type="text"
                              value={this.state.formState.AnkleCirc.value}
                              error={
                                this.handleError("AnkleCirc") &&
                                this.state.isSubmit
                              }
                              onChange={(e) => {
                                this.onInputChange(e, "AnkleCirc");
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

              
            </div>

            <div>
              <SocketMaterial
                options={this.preventPolyCoOnExoLaminationSelection()}
                fileChange={this.onFileChange}
                removeFile={this.removeFile}
                addExistingFile={this.addFile}
                fileName={this.state.formState.cadFileName.value}
                error={
                  this.handleError("socketMaterial") && this.state.isSubmit
                }
                revoFitEnabled={this.state.formState.revoFitEnabled.value}
                revoOptionDefaultValue={this.state.formState.revoFit.value}
                required={this.state.formState["socketMaterial"].isRequired}
                SocketMaterialDefaultValue={
                  this.state.formState.socketMaterial.value
                }
                insertMaterialDefaultValue={
                  this.state.formState.insertMaterial.value
                }
                insertMaterial={this.state.insertMaterials}
                setActiveInnerStep={this.props.setActiveInnerStep}
                setActiveInnerStepId={4}
                checkBoxes={this.state.revoFitOptions}
                labelOnChange={(e, id) => {
                  this.props.setActiveInnerStep(5);
                  this.onCheckboxChange(e, id, "revoFitEnabled");
                }}
                onChange={(e) => {
                  this.props.setActiveInnerStep(3);
                  this.onRadioChange(e, "socketMaterial");
                  this.getFormSteps();
                }}
                checkChange={(e, id) => {
                  this.props.setActiveInnerStep(4);
                  this.onCheckboxChange(e, id, "insertMaterial");
                }}
                revoChange={(e, id) => {
                  this.props.setActiveInnerStep(5);
                  this.onCheckboxChange(e, id, "revoFit");
                }}
                additionalWindowValue={this.state.formState.additionalRevoFitWindows.value}
                additionalWindowRequired={this.state.formState.additionalRevoFitWindows.isRequired}
                additionalWindowChange={e => this.onInputChange(e, "additionalRevoFitWindows")}
              />
            </div>
            {(this.state.formState.socketFinish.isRequired) && 
              (
              <div className="fieldBorder">
                <h4 className="headLable">
                  <b>Socket Finish</b>
                  {this.state.formState.socketFinish.isRequired ? <span style={{ color: "red" }}> *</span> : ""}
                </h4>
                <div className="radioGroup">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={this.state.formState.socketFinish.value}
                      defaultValue={this.state.formState.socketFinish.value}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        this.setState({
                          selectedValue: newValue,
                        });
                        this.props.setActiveInnerStep(12);
                        this.onRadioChange(e, "socketFinish");
                      }}
                      name="radio-buttons-group"
                      row
                      required={this.state.formState["socketFinish"].isRequired}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <FormLabel id="demo-radio-buttons-group-label">
                          Default
                        </FormLabel>
                        {[this.state.socketFinishes[0]].map((name) => (
                          <FormControlLabel
                            key={name.id}
                            value={name.id}
                            control={<Radio />}
                            label={
                              <div className="radioLabel">
                                <div className="radioIcon">
                                  <span>{name.displayName}</span>
                                </div>

                                <span>{name.partNumbers}</span>
                              </div>
                            }
                            className={`${
                              parseInt(this.selectedValue) === name.id
                                ? "checkedLabel"
                                : this.state.formState.socketFinish.value ===
                                  name.id
                                ? "checkedLabel"
                                : ""
                            }`}
                          />
                        ))}
                      </div>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <FormLabel id="demo-radio-buttons-group-label">
                          Skin Tone
                        </FormLabel>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "16px",
                          }}
                        >
                          {this.state.socketFinishes
                            .filter((finish) =>
                              this.isPRSOption(finish.displayName)
                            )
                            .map((name) => (
                              <FormControlLabel
                                key={name.id}
                                value={name.id}
                                control={<Radio />}
                                label={
                                  <div
                                    className="radioLabel"
                                    // style={{ display: "flex" }}
                                  >
                                    <div className="radioIcon">
                                      <span>{name.displayName}</span>
                                    </div>

                                    <span>{name.partNumbers}</span>
                                  </div>
                                }
                                className={`${
                                  parseInt(this.selectedValue) === name.id
                                    ? "checkedLabel"
                                    : this.state.formState.socketFinish
                                        .value === name.id
                                    ? "checkedLabel"
                                    : ""
                                }`}
                              />
                            ))}
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <FormLabel id="demo-radio-buttons-group-label">
                          Decorative Lamination
                        </FormLabel>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "start",
                            flexWrap: "wrap",
                            gap: "16px",
                          }}
                        >
                          {this.state.socketFinishes
                            .filter(
                              (finish) => !this.isPRSOption(finish.displayName)
                            )
                            .slice(1)
                            .map((name) => (
                              <div key={name.id}>
                              <FormControlLabel
                                value={name.id}
                                control={<Radio />}
                                label={
                                  <div className="radioLabel">
                                    <div className="radioIcon">
                                      <span>{name.displayName}</span>
                                    </div>

                                    <span>{name.partNumbers}</span>
                                  </div>
                                }
                                className={`${
                                  parseInt(this.selectedValue) === name.id
                                    ? "checkedLabel"
                                    : this.state.formState.socketFinish
                                        .value === name.id
                                    ? "checkedLabel"
                                    : ""
                                }`}
                              />

                                {(name.id ===
                                  this.customerSuppliedFabricId &&
                                  this.state.formState.socketFinish.value ===
                                  this.customerSuppliedFabricId) ?
                                  <div className="radioGroup mt-3">
                                    <div className="radioLabel">
                                      <InputTextField
                                        label={name.displayName + " Name"}
                                        variant="outlined"
                                        placeholder={"Fabric"}
                                        type="text"
                                        required={false}
                                        value={this.state.formState.customerSuppliedFabric.value}
                                        fullWidth={true}
                                        onChange={(e) => {
                                          this.onInputChange(e, "customerSuppliedFabric")
                                        }}
                                      />
                                    </div>
                                  </div>
                                  : <></>}
                              </div>
                            ))}
                        </div>

                      </div>
                    </RadioGroup>
                  </FormControl>
                  {this.handleError("socketFinish") && this.state.isSubmit && (
                    <Alert
                      severity="error"
                      style={{ padding: "0px 16px", marginTop: "12px" }}
                    >
                      Select an option
                    </Alert>
                  )}
                </div>
              </div>
            )}

            <div className="fieldBorder">
              <h4 className="headLable">Suspension</h4>
              <MuiRadio
                options={this.state.locks}
                defaultValue={this.state.formState.lock.value}
                label="Lock"
                error={this.handleError("lock") && this.state.isSubmit}
                required={this.state.formState["lock"].isRequired}
                checked
                onChange={(e) => {
                  this.props.setActiveInnerStep(6);
                  this.onRadioChange(e, "lock");
                }}
                onInputChange={this.onInputChange}
                customerSuppliedField={"customerSuppliedLock"}
                customerSuppliedFieldValue={this.state.formState.customerSuppliedLock.value}
              />

              <MuiRadio
                options={this.state.valves}
                defaultValue={this.state.formState.valve.value}
                label="Valve"
                required={this.state.formState["valve"].isRequired}
                error={this.handleError("valve") && this.state.isSubmit}
                onChange={(e) => {
                  this.props.setActiveInnerStep(6);
                  this.onRadioChange(e, "valve");
                }}
                onInputChange={this.onInputChange}
                customerSuppliedField={"customerSuppliedValve"}
                customerSuppliedFieldValue={this.state.formState.customerSuppliedValve.value}
              />
            </div>

            <div className="fieldBorder">
              <div className="radioGroup">
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={this.state.formState.mountingPlate.value}
                    defaultValue={this.state.formState.mountingPlate.value}
                    onChange={(e) => {
                      this.props.setActiveInnerStep(7);
                      this.onRadioChange(e, "mountingPlate");
                    }}
                    name="radio-buttons-group"
                    row
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <FormLabel id="demo-radio-buttons-group-label">
                        Mounting Plate{" "}
                        {this.state.formState["mountingPlate"].isRequired ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : (
                          ""
                        )}
                      </FormLabel>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "start",
                          flexWrap: "wrap",
                          gap: "16px",
                        }}
                      >
                        {this.state.mountingPlates
                          .filter(
                            (plate) => !plate.displayName.includes("Prong")
                          )
                          .map((plate) => (
                            <div key={plate.id}>
                            <FormControlLabel
                              value={plate.id}
                              control={<Radio />}
                              label={
                                <div className="radioLabel">
                                  <div className="radioIcon">
                                    <span>{plate.displayName}</span>
                                  </div>

                                  {/* <span>{plate.partNumbers}</span> */}
                                </div>
                              }
                              className={`${
                                parseInt(this.selectedValue) === plate.id
                                  ? "checkedLabel"
                                  : this.state.formState.mountingPlate.value ===
                                    plate.id
                                  ? "checkedLabel"
                                  : ""
                              }`}
                            />
                              {(plate.id ===
                                this.customerSuppliedPlateId &&
                                this.state.formState.mountingPlate.value ===
                                this.customerSuppliedPlateId) ?
                                <div className="radioGroup mt-3">
                                  <div className="radioLabel">
                                    <InputTextField
                                      label={plate.displayName + " Name"}
                                      variant="outlined"
                                      placeholder={"Plate"}
                                      type="text"
                                      required={false}
                                      value={this.state.formState.customerSuppliedPlate.value}
                                      fullWidth={true}
                                      onChange={(e) => {
                                        this.onInputChange(e, "customerSuppliedPlate")
                                      }}
                                    />
                                  </div>
                                </div>
                                : <></>}
                            </div>
                          ))}
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <FormLabel id="demo-radio-buttons-group-label">
                        WW SS 3-Prong
                      </FormLabel>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "16px",
                        }}
                      >
                        {this.state.mountingPlates
                          .filter((plate) =>
                            plate.displayName.includes("Prong")
                          )
                          .map((plate) => (
                            <FormControlLabel
                              key={plate.id}
                              value={plate.id}
                              control={<Radio />}
                              label={
                                <div className="radioLabel">
                                  <div className="radioIcon">
                                    <span>{plate.displayName}</span>
                                  </div>

                                  {/* <span>{plate.partNumbers}</span> */}
                                </div>
                              }
                              className={`${
                                parseInt(this.selectedValue) === plate.id
                                  ? "checkedLabel"
                                  : this.state.formState.mountingPlate.value ===
                                    plate.id
                                  ? "checkedLabel"
                                  : ""
                              }`}
                            />
                          ))}
                        {this.handleError("mountingPlate") &&
                          this.state.isSubmit && (
                            <Alert
                              severity="error"
                              style={{
                                padding: "0px 16px",
                                marginTop: "12px",
                              }}
                            >
                              Select an option
                            </Alert>
                          )}
                      </div>
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
            </div>

            <div className="fieldBorder">
              <MuiRadio
                options={this.state.prostheticHeights}
                label="Prosthetic Height Adjustment"
                defaultValue={this.state.formState.prostheticHeight.value}
                required={this.state.formState["prostheticHeight"].isRequired}
                error={
                  this.handleError("prostheticHeight") && this.state.isSubmit
                }
                onChange={(e) => {
                  this.props.setActiveInnerStep(8);
                  this.onRadioChange(e, "prostheticHeight");
                }}
              />
              {this.showAmount("UOM")}
            </div>

            <div className="fieldBorder">
              <MuiRadio
                options={this.state.modifications}
                defaultValue={this.state.formState.modification.value}
                label="Modifications"
                error={
                  this.handleError("modification") && this.state.isSubmit
                }
                required={true}
                onChange={(e) => {
                  this.props.setActiveInnerStep(9); 
                  this.onRadioChange(e, "modification");
                }}
              />
              <div className="fieldWrapper ">{this.showAmount("modification")}</div>
            </div>

            <div className="msgBox fieldBorder msgBoxWidth">
              <div className="possibelDate">
                <div>
                  <h4 className="headLable"><b>Earliest Ship Date</b>: {this.formatShipDate(this.state.estimatedShipDate)}</h4>
                </div>
              </div>
              <InputTextField
                label="Items sent in with socket"
                variant="outlined"
                placeholder="Type Something here..."
                type="text"
                width="800px"
                multiline
                rows={6}
                value={this.state.formState.itemsSentIn.value}
                required={this.state.formState["itemsSentIn"].isRequired}
                error={this.handleError("itemsSentIn") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "itemsSentIn");
                  this.props.setActiveInnerStep(10);
                }}
              />
            </div>

            <div className="msgBox msgBoxWidth">
              <h4 className="headLable"> Notes</h4>
              <InputTextField
                label="Other Notes"
                variant="outlined"
                placeholder="Type Something here..."
                type="text"
                width="800px"
                multiline
                rows={6}
                value={this.state.formState.notes.value}
                error={this.handleError("notes") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "notes");
                  this.props.setActiveInnerStep(11);
                }}
              />
            </div>
          </form>
        </div>
        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text = "Clear the Order?"
            onClick = {this.props.handleClickClearOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                this.setState({ isLoading: true });
                this.saveData();
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId = {this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
        />
      </div>
    );
  }

  isRevoFitEnabled() {
    return this.state.formState.revoFitEnabled.value;
  }

  isAdditionalWindowSelected() {
    return this.state.formState.revoFit.value[this.additionalWindowId];
  }

  convertMeasurements(e, label, uomRadio) {
    const cmMax = this.maxCMProstheticHeightAdjustment
    const inMax = this.maxInchProstheticHeightAdjustment
    let conversion = 0;
    const isCM = parseInt(e.target.value) === this.uomMetric;
    const isIn = parseInt(e.target.value) === this.uomImperial;
    if (isCM) {
      conversion = this.state.formState.amount.value * this.conversionFactor;
      if (conversion > cmMax) {
        conversion = cmMax;
      }
      conversion = parseFloat(conversion.toFixed(1));
    } else {
      conversion = this.state.formState.amount.value / this.conversionFactor;
      if (conversion > inMax) {
        conversion = inMax;
      }
      conversion = parseFloat(conversion.toFixed(3));
    }

    this.state.formState.amount.value = conversion;
    uomRadio.onRadioChange(e, label);
  }

  showAmount(section) {
    if (section === "UOM") {
      if (this.isShortenSelected() || this.isExtendSelected()) {
        return (
          <>
            <Form.Group controlId="amount">
              <MuiRadio
                options={this.state.prostheticHeightUOMs}
                label="Unit of Measurement"
                required={true}
                defaultValue={this.state.formState.prostheticHeightUOM.value}
                onChange={(e) => {
                  this.props.setActiveInnerStep(8);
                  this.convertMeasurements(e, "prostheticHeightUOM", this);
                }}
              />
            </Form.Group>
            <Form.Group controlId="amount">
              <RangeSlider
                label="Amount"
                unit={this.getAmountText("UOM")}
                min={0}
                minValue={this.isCMSelected() ? "0cm" : "0in"}
                maxValue={this.isCMSelected() ? this.maxCMProstheticHeightAdjustment + "cm" : this.maxInchProstheticHeightAdjustment + "in"}
                max={this.isCMSelected() ? this.maxCMProstheticHeightAdjustment : this.maxInchProstheticHeightAdjustment}
                step={this.isCMSelected() ? 0.1 : 0.125}
                initialValue={this.state.formState.amount.value}
                onChange={(e) => {
                  this.handleAmountChange(e, "UOM")
                  this.props.setActiveInnerStep(8);  
                }}
                valueLabelDisplay="auto"
                aria-labelledby="continuous-slider-always"
              />
            </Form.Group>
          </>
        );
      }
    } else {
      if (section === "modification") {
        if (this.isPercentageSelected() || this.isPlySelected()) {
          return (
            <Form.Group controlId="amount">
              <div className="range">
                <RangeSlider
                  min={-10}
                  max={10}
                  step={1}
                  minValue={"-10"}
                  maxValue={"+10"}
                  unit={this.getAmountText("modification")}
                  label={`Amount`}
                  initialValue={this.state.formState.modificationPercentage.value}
                  onChange={(e) => {
                    this.handleAmountChange(e, "modification")
                    this.props.setActiveInnerStep(9); 
                  }}
                  valueLabelDisplay="auto"
                  aria-labelledby="continuous-slider-always"
                  allowsNegativeNumbers={true}
                />
              </div>
            </Form.Group>
          );
        }
      }
    }
  }

  updateSocketRequired() {
    let required = this.state.formState.socketMaterial.value === this.fromCarbonCastId ||
      this.state.formState.socketMaterial.value === this.fromCADFileId ||
      this.state.formState.socketMaterial.value === null;

    let formState = this.state.formState;

    formState.socketFinish.isRequired = required;
    if (!required) {
      formState.socketFinish.value = null;
    }
    this.setState({ formState: formState });

    return required;
  }

  isPRSOption(option) {
    return option.includes("PRS");
  }

  isCMSelected() {
    return this.state.formState.prostheticHeightUOM.value === this.uomMetric;
  }

  isShortenSelected() {
    return this.state.formState.prostheticHeight.value === this.shortenId;
  }

  isExtendSelected() {
    return this.state.formState.prostheticHeight.value === this.extendId;
  }
}

export default TFDefinitiveMeasurement;
